import { ECheckEmailStatus, EAuthenticateStatus, ERestoreStatus, ETwoFactorStatus } from '../../types/authentication';
export var defaultState = {
  checkEmail: {
    status: ECheckEmailStatus.Initial
  },
  authenticate: {
    status: EAuthenticateStatus.Initial
  },
  twoFactor: {
    status: ETwoFactorStatus.Initial
  },
  restore: {
    status: ERestoreStatus.Initial
  },
  password: ''
};